module.exports = __webpack_public_path__ + "img/monitor.6d47e4c.svg";